// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgSocialDiscord24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill="currentColor"
			d="M20.317 4.493c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 0 0-.079.036c-.21.369-.444.85-.607 1.23a18.566 18.566 0 0 0-5.488 0 12.358 12.358 0 0 0-.617-1.23.077.077 0 0 0-.079-.038c-1.714.29-3.354.8-4.885 1.491a.07.07 0 0 0-.032.027C.533 9.094-.32 13.556.1 17.962a.08.08 0 0 0 .031.055 20.031 20.031 0 0 0 5.993 2.98.078.078 0 0 0 .084-.026c.463-.619.873-1.276 1.226-1.963a.074.074 0 0 0-.04-.104 13.211 13.211 0 0 1-1.873-.878.075.075 0 0 1-.008-.125c.126-.093.252-.19.372-.287a.076.076 0 0 1 .078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 0 1 .08.009c.12.098.244.195.371.288a.075.075 0 0 1 .02.1.076.076 0 0 1-.026.025c-.598.344-1.22.635-1.872.877a.075.075 0 0 0-.041.105c.36.687.771 1.341 1.224 1.962a.078.078 0 0 0 .084.028 19.966 19.966 0 0 0 6.003-2.981.076.076 0 0 0 .032-.054c.5-5.094-.838-9.52-3.55-13.442a.06.06 0 0 0-.03-.028ZM8.02 15.279c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.177 1.077 2.158 2.38 0 1.312-.957 2.38-2.158 2.38Zm7.976 0c-1.184 0-2.158-1.069-2.158-2.38 0-1.312.956-2.38 2.158-2.38 1.21 0 2.176 1.077 2.156 2.38 0 1.312-.946 2.38-2.157 2.38Z"
		/>
	</svg>
);
export default SvgSocialDiscord24;
